// Action Types for Fetching Configurables
export const FETCH_CONFIGURABLES_REQUEST = 'FETCH_CONFIGURABLES_REQUEST';
export const FETCH_CONFIGURABLES_SUCCESS = 'FETCH_CONFIGURABLES_SUCCESS';
export const FETCH_CONFIGURABLES_FAILURE = 'FETCH_CONFIGURABLES_FAILURE';

// Action Types for Updating Configurable
export const UPDATE_CONFIGURABLE_REQUEST = 'UPDATE_CONFIGURABLE_REQUEST';
export const UPDATE_CONFIGURABLE_SUCCESS = 'UPDATE_CONFIGURABLE_SUCCESS';
export const UPDATE_CONFIGURABLE_FAILURE = 'UPDATE_CONFIGURABLE_FAILURE';

// Action Creators for Fetching Configurables
export const fetchConfigurablesRequest = () => ({
  type: FETCH_CONFIGURABLES_REQUEST,
});

export const fetchConfigurablesSuccess = (data) => ({
  type: FETCH_CONFIGURABLES_SUCCESS,
  payload: data,
});

export const fetchConfigurablesFailure = (error) => ({
  type: FETCH_CONFIGURABLES_FAILURE,
  payload: error,
});

// Action Creators for Updating Configurable
export const updateConfigurableRequest = (key, value) => ({
  type: UPDATE_CONFIGURABLE_REQUEST,
  payload: { key, value },
});

export const updateConfigurableSuccess = (data) => ({
  type: UPDATE_CONFIGURABLE_SUCCESS,
  payload: data,
});

export const updateConfigurableFailure = (error) => ({
  type: UPDATE_CONFIGURABLE_FAILURE,
  payload: error,
});
